import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { alertModal, loginAlertModal } from '@apply/ui';
import { Header } from '../Header';
import { useAuthentication } from '../LoginPage';
import LoadPanel from 'devextreme-react/load-panel';
import { FeatureType } from '@apply/constants';
import { HomePageLink } from '../HomePageLink';
import BusinessAndPeoplePanel from '../business/BusinessAndPeoplePanel';
import BusinessAndPeopleUmbrellaBusinessPanel from '../business/BusinessAndPeopleUmbrellaBusinessPanel';
import { applicationInsights } from '../../app/ApplicationInsights';

const BusinessAndPeoplePage = () => {
    const { isRegisteredUser, authentication, logout, isFeatureEnabled } = useAuthentication();
    const [loadError, setLoadError] = useState<string>('');
    const [currentTopLevelBusiness, set_currentTopLevelBusiness] = useState(0);

    const [loadingOpen] = useState<boolean>(false);
    const [loadingMessage] = useState<string>('Loading...');

    const styles = {
        businessAndPeopleSectionContainer: {
            width: '100%' as const,
            display: 'flex',
        },
    };

    const updateCurrentTopLevelBusiness = (selectedTopLevelBusiness) => {
        set_currentTopLevelBusiness(selectedTopLevelBusiness);
    };

    const thisLocation = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (loadError) {
            if (String(loadError).includes('401 - User not Authorized.')) {
                loginAlertModal({
                    onConfirm: () => {
                        setLoadError(undefined);
                        logout();
                        navigate(`/login?redirectTo=${thisLocation.pathname}`);
                    },
                });
            } else {
                alertModal({
                    message: 'An error has occurred while communicating with our server.  Please try your operation again.',
                    onConfirm: () => {
                        setLoadError(undefined);
                    },
                });
            }
        }
    }, [navigate, loadError, logout, thisLocation.pathname]);

    if (!isRegisteredUser || !authentication?.username) {
        return (
            <LoadPanel
                hideOnOutsideClick={false}
                visible={true}
                message={'Loading...'}
            />
        );
    }

    if (!isFeatureEnabled(FeatureType.BusinessAndPeopleHierarchy)) {
        window.location.href = '/home';
    }

    return (
        <div className='app-container home-page-container'>
            <Header />
            <main>
                <HomePageLink />
                <h2>Business and People</h2>
                <section>
                    <div
                        className='columns small-12 large-12'
                        style={{ textAlign: 'right' }}
                    >
                        Welcome back, {authentication?.user?.firstName} {authentication?.user?.lastName}!
                    </div>
                </section>
                <section>
                    <BusinessAndPeopleUmbrellaBusinessPanel
                        updateCurrentBusiness={updateCurrentTopLevelBusiness}
                        applicationInsights={applicationInsights}
                    />
                </section>
                <section>
                    <div style={styles.businessAndPeopleSectionContainer}>
                        {!loadingOpen && (
                            <BusinessAndPeoplePanel
                                applicationInsights={applicationInsights}
                                currentTopLevelBusiness={currentTopLevelBusiness}
                            />
                        )}
                    </div>
                </section>
            </main>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </div>
    );
};

export default BusinessAndPeoplePage;
